import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { updateOrder } from 'actions/orders';
import { fetchCouncil } from 'actions/councils';
import { councilSelector, addressDisplaySelector } from 'selectors/order-create';

import Card from 'components/common/Card';
import LoadingSpinner from 'components/LoadingSpinner';

import {
  FlexItem,
  StepTitle,
  FlexContain,
  ContentContain,
  StepInformation,
  LoadingContain
} from '../CreateStyled';

import CertificateItem from '../CertificateItem';

import { stepCertificates as handleValidate } from '../validation/';

export const StepCertificates = ({
  council,
  loading,
  updateOrder,
  fetchCouncil,
  renderActions,
  selectedCertificate
}) => {
  useEffect(() => {
    fetchCouncil(council.id);
  }, [fetchCouncil, council.id]);

  const handleNext = () => {
    return handleValidate({ selectedCertificate });
  };

  const handleCertSelect = (certId) => {
    updateOrder({ selected_certificate: certId });
  };

  const renderCertificates = () =>
    council.items &&
    council.items.map((item) => (
      <CertificateItem
        item={item}
        key={item.id}
        onClick={handleCertSelect.bind(null, item.id)}
        selected={selectedCertificate === item.id}
      />
    ));

  return (
    <React.Fragment>
      <Card.Content>
        <ContentContain>
          <StepTitle>Council Search</StepTitle>
          <StepInformation>
            Select your search requirements from the options below
          </StepInformation>

          {loading ? (
            <LoadingContain>
              <LoadingSpinner large />
              Loading Council Items...
            </LoadingContain>
          ) : (
            <FlexContain>
              <FlexItem flex={2}>{renderCertificates()}</FlexItem>
            </FlexContain>
          )}

          {!loading && renderActions({ disableNext: !selectedCertificate, onNext: handleNext })}
        </ContentContain>
      </Card.Content>
    </React.Fragment>
  );
};

StepCertificates.defaultProps = {
  inputErrors: {},
  onValueChange: () => null
};

export default connect(
  (state) => ({
    session: state.session,
    council: councilSelector(state),
    loading: state.loading.loadingCouncil,
    addressDisplay: addressDisplaySelector(state),
    selectedCouncil: state.pendingOrder.pending.selected_council,
    selectedCertificate: state.pendingOrder.pending.selected_certificate
  }),
  {
    dispatchOrderUpdate: updateOrder,
    dispatchGetCouncil: fetchCouncil,
  })(props => <StepCertificates 
    {...props}
    updateOrder={props.dispatchOrderUpdate}
    fetchCouncil={props.dispatchGetCouncil}
  />
);
